import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  query,
  collection,
  where,
  getDocs,
  orderBy,
  deleteDoc,
  doc,
  getDoc,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  Timestamp,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import CompanyLogosvg from "assets/studyGramLogo/studygram_logo.png";

function SalaryExpensesList() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [expenseData, setExpenseData] = useState([]);
  const [teachersData, setTeachersData] = useState([]);
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [filteredDates, setFilteredDates] = useState(new Date());
  const [isAdmin, setIsAdmin] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(null);

  // MARK: checkUserRole
  function checkUserRole() {
    const userInfo = JSON.parse(localStorage.getItem("session"));
    setIsAdmin(userInfo.role === "admin");
  }

  // MARK: use Effect function
  useEffect(() => {
    checkUserRole();
    fetchExpenseApi();
    fetchTeacherApi();
    fetchProfileData();
  }, []);

  // use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.expenseListLayoutHeading;
  }, []);

  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  const salaryExpenseCategory = (teacherModel) => {
    var teacherObject = teachersData.find(function (teacher) {
      return teacher.firebase_id === teacherModel.teacher_id;
    });
    return `${teacherObject?.name}`;
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;
      paginationQuery = query(
        collection(dbFirestore, TableName.salaryExpenses),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at),
      );

      const querySnapshot = await getDocs(paginationQuery);

      setExpenseData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id })),
      );

      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (expenseData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  // MARK: previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.salaryExpenses),
      orderBy("created_at", "desc"),
      endBefore(expenseData[0].created_at),
      limitToLast(Constant.perPage),
    );

    const querySnapshot = await getDocs(paginationQuery);

    setExpenseData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id })),
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (expenseData.length === 0) {
      fetchExpenseApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      var firstDay = new Date(
        filteredDates.getFullYear(),
        filteredDates.getMonth(),
        1,
      );
      var lastDay = new Date(
        filteredDates.getFullYear(),
        filteredDates.getMonth() + 1,
        0,
      );

      const startTimestamp = Timestamp.fromDate(firstDay).toMillis();
      const endTimestamp = Timestamp.fromDate(lastDay).toMillis();

      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  // MARK: tap on button
  const tapOnEdit = (expenseData) => () => {
    navigate(RoutingPaths.editSalaryExpenses, { state: expenseData });
  };

  const tapOnDeleteConfirm = (expenseData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this expense data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteExpenseApi(expenseData);
      }
    });
  };

  const tapOnSalarySlip = (expenseData) => () => {
    navigate(RoutingPaths.salarySlip, { state: expenseData });
  };

  const tapOnResetButton = () => {
    setFilteredDates(new Date());
    fetchExpenseApi(new Date());
  };

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />;
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.salaryExpenses),
        where("salary_month_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("salary_month_num", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc"),
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.salaryExpenses),
        where("salary_month_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("salary_month_num", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));
    setExpenseData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // MARK: API
  // delete API
  const deleteExpenseApi = async (expenseData) => {
    await deleteDoc(doc(dbFirestore, TableName.salaryExpenses, expenseData.id));
    setExpenseData((prevState) =>
      prevState.filter((el) => el.id !== expenseData.id),
    );
    toast.success(ToastMessages.expenseDeleted);
  };

  // fetch  API's
  async function fetchExpenseApi(currentMonth) {
    var expenseQuery;

    expenseQuery = query(
      collection(dbFirestore, TableName.salaryExpenses),
      where("salary_month_num", ">=", getFilteredDatesTimeStamp().startTime),
      where("salary_month_num", "<=", getFilteredDatesTimeStamp().endTime),
      orderBy("created_at", "desc"),
      limit(Constant.perPage),
    );

    expenseQuery = query(
      collection(dbFirestore, TableName.salaryExpenses),
      where(
        "salary_month",
        ">=",
        moment(currentMonth).format(Dateformat.MMYYYY),
      ),
      orderBy("created_at", "desc"),
      limit(Constant.perPage),
    );
    const querySnapshot = await getDocs(expenseQuery);
    const expenseObject = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    setExpenseData(expenseObject);
    setPage(0);
    setLoading(false);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // teacher api
  async function fetchTeacherApi() {
    let q = query(collection(dbFirestore, TableName.teachers));

    const querySnapshot = await getDocs(q);
    setTeachersData(
      querySnapshot.docs.map((docs) => ({
        ...docs.data(),
        firebase_id: docs.id,
      })),
    );
  }

  // profile api
  async function fetchProfileData() {
    let q = query(collection(dbFirestore, TableName.profile));
    const querySnapshot = await getDocs(q);
    const profileArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));
    setProfileData(profileArray);
  }

  // Helper function to capitalize text
  const capitalizeText = (text) => {
    if (!text) return "";
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  function capitalize(text) {
    return text.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function numberToWords(num) {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";

    function inWords(n) {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
      if (n < 100000)
        return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
      if (n < 10000000)
        return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);
      return (
        inWords(Math.floor(n / 10000000)) + " Crore " + inWords(n % 10000000)
      );
    }

    return inWords(num).trim();
  }

  // Direct download salary slip PDF
  const directDownloadSalarySlip = async (expenseModal) => {
    setIsDownloading(expenseModal.id);

    try {
      // Fetch teacher data
      const docRef = doc(
        dbFirestore,
        TableName.teachers,
        expenseModal.teacher_id,
      );
      const docSnap = await getDoc(docRef);
      const teacherData = docSnap.exists() ? docSnap.data() : null;

      // Calculate salary breakdown
      const salaryAmount = expenseModal.salary_num;
      const halfSalary = salaryAmount / 2;
      const forthPortionFromSalary = halfSalary / 4;
      const quarterhalf = (halfSalary - forthPortionFromSalary) / 2;

      const teacherSalary = {
        basic: halfSalary,
        hra: quarterhalf,
        conveyance: quarterhalf,
        other: forthPortionFromSalary,
      };

      const daysInCurrentMonth = moment(
        expenseModal.salary_month_num,
      ).daysInMonth();
      const restDays = daysInCurrentMonth - expenseModal.no_of_days;
      const profile = profileData[0];

      // Create HTML content for PDF matching the original salary slip design
      const htmlContent = `
        <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px; margin: 0 auto; font-size: 14px;">
          <!-- Header Section -->
          <div style="display: flex; align-items: flex-start; margin-bottom: 15px;">
            <div style="padding:10px;">
  <img 
    src="${CompanyLogosvg}" 
    alt="Logo" 
    style="width:150px; height:auto; image-rendering: -webkit-optimize-contrast;"
  />
</div>


            <div style="width: 80%; text-align: right;">
<h1 style="margin: 0; font-size: 22px; color: #333; font-weight: bold;">
  ${capitalize(profile?.business_name || "")}
</h1>

<p style="margin: 3px 0; font-size: 13px; color: #555;">
  ${capitalize(profile?.address || "")}
</p>
              <p style="margin: 3px 0; font-size: 13px; color: #555;">Mob. : ${profile?.phone || ""}, ${profile?.second_phone || ""}</p>
              <p style="margin: 10px 0 0 0; font-size: 15px; font-weight: bold; background: #f5f5f5; padding: 8px; border-radius: 4px;">
                Salary Slip For the Month of ${moment(expenseModal.salary_month_num).format(Dateformat.MMMMYYYY)}
              </p>
            </div>
          </div>

          <!-- Employee Details Section -->
          <div style="border-top: 3px solid #dc3545; padding: 12px 5px; margin-bottom: 10px;">
            <div style="display: flex; margin-bottom: 8px;">
              <div style="width: 50%; text-transform: capitalize;">
                <strong>Emp. Name:-</strong> ${capitalizeText(teacherData?.name)}
              </div>
              <div style="width: 50%; text-transform: capitalize;">
                <strong>Father's Name:-</strong> ${capitalizeText(teacherData?.father_husband_name)}
              </div>
            </div>
            <div style="display: flex;">
              <div style="width: 50%; text-transform: capitalize;">
                <strong>Department:-</strong> ${capitalizeText(teacherData?.department)}
              </div>
              <div style="width: 50%; text-transform: capitalize;">
                <strong>Designation:-</strong> ${capitalizeText(teacherData?.designation)}
              </div>
            </div>
          </div>

          <!-- Salary Table -->
          <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
            <!-- Table Header -->
            <thead>
              <tr style="background: #f0f0f0;">
                <th style="border: 1px solid #333; padding: 10px; text-transform: uppercase; font-size: 12px; width: 33.33%;">Total Days (A)</th>
                <th style="border: 1px solid #333; padding: 10px; text-transform: uppercase; font-size: 12px; width: 33.33%;">Rate of Pay (B)</th>
                <th style="border: 1px solid #333; padding: 10px; text-transform: uppercase; font-size: 12px; width: 33.33%;">Salary Earned (C)</th>
              </tr>
            </thead>
            <tbody>
              <!-- Row 1: Worked / Basic / Salary -->
              <tr>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Worked</span>
                    <span>${expenseModal.no_of_days}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Basic</span>
                    <span>${teacherSalary.basic}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px; text-align: right;">${expenseModal.salary_num}</td>
              </tr>
              <!-- Row 2: Rest / H.R.A. -->
              <tr>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Rest</span>
                    <span>${restDays}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>H.R.A.</span>
                    <span>${teacherSalary.hra}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px; text-align: right;">-</td>
              </tr>
              <!-- Row 3: C.L. / Conveyance -->
              <tr>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>C.L.</span>
                    <span>-</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Conveyance</span>
                    <span>${teacherSalary.conveyance}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px; text-align: right;">-</td>
              </tr>
              <!-- Row 4: E.L. / Others -->
              <tr>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>E.L.</span>
                    <span>-</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Others</span>
                    <span>${teacherSalary.other}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px; text-align: right;">-</td>
              </tr>
              <!-- Row 5: Holidays -->
              <tr>
                <td style="border: 1px solid #333; padding: 8px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Holidays</span>
                    <span>-</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; padding: 8px;"></td>
                <td style="border: 1px solid #333; padding: 8px;"></td>
              </tr>
              <!-- Total Row -->
              <tr style="font-weight: bold; text-transform: uppercase; border-top: 3px solid #333;">
                <td style="border: 1px solid #333; border-bottom: 3px solid #dc3545; padding: 10px;">
                  <div style="display: flex; justify-content: space-between;">
                    <span>Total</span>
                    <span>${daysInCurrentMonth}</span>
                  </div>
                </td>
                <td style="border: 1px solid #333; border-bottom: 3px solid #dc3545; padding: 10px; text-align: right;">${expenseModal.salary_num}</td>
                <td style="border: 1px solid #333; border-bottom: 3px solid #dc3545; padding: 10px; text-align: right;">${expenseModal.salary_num}</td>
              </tr>
            </tbody>
          </table>

          <!-- Net Amount Section -->
          <div style="background: rgba(255,251,177,255); padding: 12px; margin-top: 10px; font-weight: 500; font-size: 15px;">
            NET AMOUNT PAYABLE(C-D): Rs.${expenseModal.salary_num?.toLocaleString()} (${numberToWords(expenseModal.salary_num)} Only)
          </div>
          <p style="margin-top: 12px; font-size: 12px; color: #666; text-align: center; font-style: italic;">
  This is a system generated salary slip. No signature is required.
</p>
        </div>
      `;

      // Create temporary element
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      document.body.appendChild(tempDiv);

      const options = {
        filename: `salary_slip_${capitalizeText(teacherData?.name) || "teacher"}_${moment(expenseModal.salary_month_num).format("MMM_YYYY")}.pdf`,
        margin: [0.5, 0.5, 0.5, 0.5],
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };

      await html2pdf().set(options).from(tempDiv).save();

      // Clean up
      document.body.removeChild(tempDiv);
      // toast.success("Salary slip downloaded successfully!");
    } catch (error) {
      console.error("Error downloading salary slip:", error);
      toast.error("Failed to download salary slip. Please try again.");
    } finally {
      setIsDownloading(null);
    }
  };

  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div" style={{ justifySelf: "end" }}>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              view="month"
              dateFormat={Dateformat.Mmyy}
              readOnlyInput
              showIcon
              placeholder="Select month"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // MARK: expense columns data
  const expenseListColumns = [
    {
      field: "teacher_id",
      header: "Name",
      className: "table__column__capital",
      CardBody: salaryExpenseCategory,
    },
    { field: "no_of_days", header: "No. of days" },
    { field: "salary", header: "Salary", CardBody: priceBodyTemplate },
    {
      field: "salary_date",
      header: "Salary Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.salary_date}</Moment>
      ),
    },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (expenseModal) => (
        <>
          <div className="d-flex mt-3 text-start">
            <Button
              type="button"
              className="lists__download_button"
              onClick={() => directDownloadSalarySlip(expenseModal)}
              tooltip="Download Salary Slip"
              tooltipOptions={{ position: "bottom" }}
              disabled={isDownloading === expenseModal.id}
            >
              <span
                className={
                  isDownloading === expenseModal.id
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-download"
                }
              ></span>
            </Button>

            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnEdit(expenseModal)}
              tooltip="edit"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-pencil"></span>
            </Button>

            {isAdmin && (
              <Button
                severity="secondary"
                type="button"
                onClick={tapOnDeleteConfirm(expenseModal)}
                className="lists__delete_button"
                tooltip="delete"
                tooltipOptions={{ position: "bottom" }}
              >
                <span className="pi pi-trash"></span>{" "}
              </Button>
            )}
          </div>
        </>
      ),
    },
  ];

  async function createQueryForExport(currentMonth) {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.salaryExpenses),
        where("salary_month_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("salary_month_num", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc"),
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.salaryExpenses),
        where(
          "salary_month",
          ">=",
          moment(currentMonth).format(Dateformat.MMYYYY),
        ),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  // MARK: modify expense model in which we add new inputs in an array
  const modifyExpenseModel = (doc) => {
    const data = doc.data();
    var teacherObject = teachersData.find(function (teacher) {
      return teacher.firebase_id === data.teacher_id;
    });
    return {
      teacher_id: teacherObject.name,
      no_of_days: data.no_of_days,
      salary: data.salary,
      salary_date: moment(data.salary_date).format(Dateformat.YYYYMMDD),
      description: data.description,
      created_at: moment(data.created_at).format(Dateformat.YYYYMMDD),
    };
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) =>
          modifyExpenseModel(model),
        );
        var expenseArray;
        expenseArray = mylist.map(
          ({
            teacher_id,
            no_of_days,
            salary,
            description,
            salary_date,
            created_at,
          }) => ({
            teacher_id: teacher_id,
            no_of_days: no_of_days,
            salary: salary,
            salary_date: salary_date,
            description: description,
            created_at: created_at,
          }),
        );
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(expenseArray);
          XLSX.utils.book_append_sheet(workBook, workSheet, "expense");
          XLSX.writeFile(workBook, "salary_expense_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate);
        }
      }
    });
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.expenseListHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addSalaryexpenses} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={expenseData}
            header={header}
            emptyMessage="No data found."
          >
            {expenseListColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: expenseData[expenseData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

const priceBodyTemplate = (expense) => {
  return `Rs ${expense.salary_num?.toLocaleString()}`;
};

export default SalaryExpensesList;
